/* TODG look-parity helpers ported from live Impact 4.6.0 */
var VariantOptionChange = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute('form')]?.addEventListener('variant:change', this._onVariantChangedListener);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute('form')]?.removeEventListener('variant:change', this._onVariantChangedListener);
  }
  _onVariantChanged(event) {
    this.innerHTML = event.detail.variant[this.getAttribute('for')];
  }
};
if (!window.customElements.get('selected-variant')) {
  window.customElements.define('selected-variant', VariantOptionChange);
}

document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant) return;
  document.querySelectorAll('.variant-notification[data-variant-id]').forEach((el) => {
    const match = parseInt(el.getAttribute('data-variant-id'), 10) === variant.id;
    el.style.display = match ? 'inline-block' : 'none';
    el.classList.toggle('hide', !match);
  });
});
